import type { KdsVerdictRowTone } from '@/kds/types';

type VerdictRow = {
  id: string;
  tone: KdsVerdictRowTone;
  text: string;
};

export type VerdictDemoData = {
  eyebrow: string;
  title: string;
  quote: string;
  meta: string;
  rows: VerdictRow[];
};

/** Static demo verdict data. Matches the editorial content defined in spec.md (section /verdict-demo). */
export const VERDICT_DEMO_DATA: VerdictDemoData = {
  eyebrow: 'VERDICT · DEMO',
  title: 'The drop-off at step 3 is structural, not cosmetic',
  quote:
    'Every persona hesitated at the pricing reveal — not because the price is wrong, but because the value frame arrived too late in the sequence.',
  meta: "Devil's Advocate · 4 turns · 6 personas · 11 insights settled",
  rows: [
    {
      id: 'demo-r-1',
      tone: 'insight',
      text: '3 of 6 personas completed step 3 only after re-reading the pricing page — confirming a sequencing issue, not a price objection.'
    },
    {
      id: 'demo-r-2',
      tone: 'insight',
      text: 'Personas from the SMB segment showed 40% lower hesitation when a social proof element was visible before the pricing reveal.'
    },
    {
      id: 'demo-r-3',
      tone: 'friction',
      text: 'The value proposition is stated after the call-to-action — personas feel asked to commit before understanding the benefit.'
    },
    {
      id: 'demo-r-4',
      tone: 'friction',
      text: 'Step 2 introduces three form fields without context; 4 of 6 personas paused or expressed uncertainty about which workspace type to select.'
    },
    {
      id: 'demo-r-5',
      tone: 'witness',
      text: "From the mid-market segment — ‘I’d sign up if I knew what happened to my data after the trial. The absence of a data retention statement is a blocker at my org level.’"
    }
  ]
};
